/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { useDeviceMediaQuery } from '../../../Shared/UseDeviceMediaQuery/useDeviceMediaQuery'

const AisleDragOverlay = ({aisle}) => {
    const { isMobile } = useDeviceMediaQuery()

    if (!aisle) return null

    return (
      <div
        css={css`
            border: 2px dashed #00b5ad;
            background-color: #e6f7f7;
            padding: ${isMobile ? '0.75rem 0.5rem' : '1rem .75rem'};
            min-height: ${isMobile ? '4rem' : '6rem'};
            display: flex;
            align-items: center;
            font-weight: bold;
            transform: scale(1.03);
            box-shadow: 0 5px 10px rgba(0, 0, 0, 0.15);
            font-size: ${isMobile ? '0.9rem' : '1rem'};
            cursor: grab;
        `}
      >
        {aisle.name}
      </div>
    )
}

export { AisleDragOverlay }
